import { getDetailLabel } from '@/shared/copy/details';
import type { CsvHeaderAliases, CsvStatusAliases } from '@flowqa/shared';

export type ValidationStatus = 'unknown' | 'valid' | 'invalid';

export const fieldOptions = [
  { key: 'suite', label: 'Suite', required: false },
  { key: 'test', label: 'Test', required: true },
  { key: 'status', label: getDetailLabel('status'), required: true },
  { key: 'duration', label: getDetailLabel('duration'), required: false },
  { key: 'timestamp', label: getDetailLabel('timestamp'), required: false },
] as const;

const joinAliases = (aliases: string[] | undefined): string => {
  if (!aliases || aliases.length === 0) return '';
  return aliases.join(', ');
};

export const buildHeaderMapping = (aliases: CsvHeaderAliases): Record<string, string> => ({
  suite: joinAliases(aliases.suite),
  test: joinAliases(aliases.test),
  status: joinAliases(aliases.status),
  duration: joinAliases(aliases.duration),
  timestamp: joinAliases(aliases.timestamp),
});

export const buildStatusMapping = (aliases: CsvStatusAliases): Record<string, string> => ({
  passed: joinAliases(aliases.passed),
  failed: joinAliases(aliases.failed),
  errored: joinAliases(aliases.errored),
  skipped: joinAliases(aliases.skipped),
  untested: joinAliases(aliases.untested),
});

export const mappingTooltipSlotProps = {
  tooltip: {
    sx: {
      fontSize: '15px',
      maxWidth: 'none',
      whiteSpace: 'nowrap',
    },
  },
};
